module.exports = __webpack_public_path__ + "static/img/clickNo.b60abf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/conSentences/clickNo.png
// module id = Fr49
// module chunks = 4